const STORAGE_KEY = "superAdminLastTenant";

/** Same-tab signal — `storage` only fires across tabs. */
export const SUPER_ADMIN_LAST_TENANT_EVENT = "adatis:super-admin-last-tenant";

export type SuperAdminLastTenant = {
  id: number;
  name: string;
};

const isValid = (value: unknown): value is SuperAdminLastTenant => {
  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as SuperAdminLastTenant;

  return (
    typeof candidate.id === "number" &&
    Number.isFinite(candidate.id) &&
    candidate.id > 0 &&
    typeof candidate.name === "string" &&
    candidate.name.trim() !== ""
  );
};

export const getSuperAdminLastTenant = (): SuperAdminLastTenant | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as unknown;
    return isValid(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const setSuperAdminLastTenant = (
  tenant: SuperAdminLastTenant
): void => {
  if (!isValid(tenant)) {
    return;
  }

  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        id: tenant.id,
        name: tenant.name.trim(),
      })
    );
    window.dispatchEvent(new Event(SUPER_ADMIN_LAST_TENANT_EVENT));
  } catch {
    // best-effort session hint
  }
};

export const clearSuperAdminLastTenant = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new Event(SUPER_ADMIN_LAST_TENANT_EVENT));
  } catch {
    // ignore
  }
};
